import home from './src/home.vue'  //监控设备管理
import monitorInfo from './src/monitorInfo.vue' //监控设备管理详情

import realTimeVideo from './src/realTimeVideo/realTimeVideoGB.vue' //实时视频
import realTimeVideoHegu from './src/realTimeVideo/realTimeVideoGBHegu.vue' //实时视频-头屯河谷
import realTimeVideoGBNew from './src/realTimeVideo/realTimeVideoGBNew.vue' // 最新的视频列表接口 样式最新的头屯河古样式
import PlaybackVideo from './src/playBackVideo/PlaybackVideo.vue' //回放视频视频
import HikPlayVideo from './src/realTimeVideo/HikPlayVideo.vue' //海康视频插件，实时预览及回放
import swiperVideo from './src/swiperVideo/swiperVideo.vue' //视频轮播
import swiperVideoList from './src/swiperVideo/swiperVideoList.vue' //视频轮播列表

import PassengerflowView from './src/Passengerflow/PassengerflowView.vue'  //客流监测集成
import PassengerflowViewDaHua from './src/Passengerflow/PassengerflowViewDaHua.vue'  //客流监测集成大华

import RealTimeVideoFlv from './src/realTimeVideo/RealTimeVideoFlv.vue' //flv版，实时预览及回放
import PlaybackVideoFlv from './src/playBackVideo/PlaybackVideoFlv.vue'
import swiperVideoFlv from './src/swiperVideo/swiperVideoFlv.vue' //视频轮播Flv



let views = {
    home,
    monitorInfo,
    realTimeVideo,
    realTimeVideoHegu,
    HikPlayVideo,
    PlaybackVideo,
    swiperVideo,
    swiperVideoList,
    PassengerflowView,
    PassengerflowViewDaHua,
    RealTimeVideoFlv,
    PlaybackVideoFlv,
    swiperVideoFlv,
    realTimeVideoGBNew
};

export default views;